<template>
  <v-dialog
      v-model="show"
      :max-width="'1200px'"
      scrollable
  >
    <v-card>
      <v-card-title>
        <v-row>
          <v-btn
                style="margin-top: 15px"
                icon
                color="dark-grey"
                :disabled="currentDate === date.split('-')[0] + '-01'"
                @click="moveDate(-1)"
                v-if="mode === 'holiday' || mode === 'ueb'"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          <v-col cols="2" style="padding: 12px 0"                 v-if="mode === 'holiday' || mode === 'ueb'"
          >
            <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="currentDate"
                persistent
                width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="formatedDate"
                    label="Zeitraum"
                    prepend-icon="mdi-calendar"
                    readonly
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="currentDate"
                  type="month"
                  scrollable
                  locale="de"
                  :min="date.split('-')[0] + '-01'"
                  :max="date.split('-')[0] + '-12'"
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="modal = false"
                >
                  Abbrechen
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="setDate(currentDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
            <v-btn
                v-if="mode === 'holiday' || mode === 'ueb'"
                style="margin-top: 15px"
                icon
                color="dark-grey"
                :disabled="currentDate === date.split('-')[0] + '-12'"
                @click="moveDate(1)"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          <v-col v-if="mode === 'holiday'" style="padding-top: 20px">
            <span>{{'Urlaub verbraucht: ' + calculateHolidayDaysPerMonth}}</span>
          </v-col>
          <v-col v-else-if="mode === 'ueb'"  style="padding-top: 20px">
            <span>{{'Überstundensaldo: ' + calculateUebPerMonth}}</span>
          </v-col>
            <span style="font-weight: bold; padding-top: 20px; margin-left: 18px; margin-right: 18px" v-if="mode !== 'holiday' && mode !== 'ueb'" >{{monthDate}}</span>
          <v-col v-if="mode !== 'holiday' && mode !== 'ueb'"  style="padding-top: 20px">
            <span>{{ lohnName + (mode !== 'rb' ? ': ' : ' ') + calculateSaldo}}</span>
          </v-col>
          <v-btn
              style="margin-top: 15px"
              icon
              color="dark-grey"
              @click="show = false; $emit('show-list', mode)"
          >
            <v-icon>mdi-view-list-outline</v-icon>
          </v-btn>
          <v-btn
              style="margin-top: 15px"
              icon
              color="dark-grey"
              @click="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text style="height: 50vh">
        <v-calendar
            ref="calendar"
            v-model="focus"
            color="blue"
            :weekday-format="myDayFormat"
            :month-format="myMonthFormate"
            :events="events"
            :event-color="getEventColor"
            type="month"
            :weekdays="weekdayOrder"
            event-more-text=""
            @click:day="eventClicked"
        >
          <template v-slot:day-label="{day, present, month, year}">
            <v-row class="m-0" style="margin-top: -6px !important;">
              <v-col v-if="!present" md="3" class="p-1"><v-btn fab  x-small depressed>{{day}}</v-btn></v-col>
              <v-col v-else md="3" class="p-1 text-left"><v-btn fab  x-small depressed color="#63c2de">{{day}}</v-btn></v-col>
            </v-row>

          </template>
          <template v-slot:event="{ event, timed, eventSummary }">
            <div>
              <!--component :is="{ render: eventSummary }"></component-->
              <div class="v-event-summary" style="color: white; padding-left: 8px; cursor: pointer">{{event.name}}</div>
            </div>
          </template>
        </v-calendar>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import _orderBy from "lodash/orderBy";
import {getUid} from "@/shared/crypto";

export default {
  name: "CalendarDialog",
  props: {
    date: {
      type: String,
      default () {
        return new Date().toISOString().substr(0, 10);
      }
    },
    holidayOverviews: {
      type: Array,
      default: () => []
    },
    uebOverviews: {
      type: Array,
      default: () => []
    },
    rbs: {
      type: Array,
      default: () => []
    },
    soll: {
      type: Array,
      default: () => []
    },
    ist: {
      type: Array,
      default: () => []
    },
    floats: {
      type: Array,
      default: () => []
    },
    lohnName: {
      type: String,
      default: ''
    },
    unitName: {
      type: String,
      default: ''
    },
  },
  mounted () {
  },
  data: () => ({
    weekdayOrder: [1, 2, 3, 4, 5, 6, 0],
    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    months: ["","Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    currentDate: new Date().toISOString().substr(0, 7),
    focus: '',
    show: false,
    events: [],
    modal: false,
    mode: 'holiday',
  }),
  computed: {
    monthDate() {
      // format to month name, Year
      let splits = this.currentDate.split("-");
      return this.monthsLong[parseInt(splits[1])] + ", " + splits[0]
    },
    formatedDate() {
      let splits = this.currentDate.split("-");
      return this.monthsLong[parseInt(splits[1])] + ", " + splits[0]
    },
    calculateSaldo() {
      switch (this.mode) {
        case 'holiday':
          return this.calculateHolidayDaysPerMonth();
        case 'ueb':
          return this.calculateUebPerMonth();
        case 'soll':
          if (!this.soll) {
            return ''
          }
          let totalSoll = 0;
          for (let i = 0; i < this.soll.length; i++) {
              totalSoll -= this.soll[i];
              totalSoll += this.ist[i];
          }
          return (totalSoll + '').replace('.', ',') + (totalSoll === 1 ? ' Stunde' : ' Stunden');
        case 'rb':
          return '';
          default:
            if (!this.floats) {
              return ''
            }
            let totalFloat = 0;
            for (let i = 0; i < this.floats.length; i++) {
                totalFloat += this.floats[i];
            }
            return (totalFloat + '').replace('.', ',') + ( ' ' + this.unitName);
      }
    },
    calculateHolidayDaysPerMonth() {
      let total = 0;
      for (let i = 0; i < this.holidayOverviews.length; i++) {
        if (this.holidayOverviews[i].date.substring(0,7) === this.currentDate) {
          total += this.holidayOverviews[i].amount;
        }
      }
      return (total + '').replace('.', ',') + (total === 1 ? ' Tag' : ' Tage');
    },
    calculateUebPerMonth() {
      let total = 0;
      for (let i = 0; i < this.uebOverviews.length; i++) {
        if (this.uebOverviews[i].date.substring(0,7) === this.currentDate) {
          total += this.uebOverviews[i].sum_pos;
          total += this.uebOverviews[i].sum_neg;
        }
      }
      return (total + '').replace('.', ',') + (total === 1 ? ' Stunde' : ' Stunden');
    },
  },
  methods: {
    eventClicked({date}) {
      this.$emit('event-clicked', date);
      this.show = false;
    },
    openDialog(mode) {
      this.mode = mode;
      this.show = true;
      this.$nextTick(() => {
        this.setDate(this.date.substring(0, 7));
        this.calculateEvents();
      });
    },
    moveDate(direction) {
      let curDate = new Date(this.currentDate + "-01");
      curDate.setMonth(curDate.getMonth() + direction);
      curDate.setHours(12)
      let date = curDate.toISOString().substring(0, 7);
      this.setDate(date);
    },
    setDate(date) {
      if (this.mode === 'holiday' || this.mode === 'ueb') {
        this.$refs.dialog.save(date);
      }
      this.currentDate = date;
      this.focus = date+"-01";
      this.$nextTick(() => {
        this.currentMonth = this.$refs.calendar.parsedValue.month;
        this.currentYear = this.$refs.calendar.parsedValue.year;
      });
    },
    getEventColor (event) {
      return event.color
    },
    myDayFormat(d) {
      return this.weekdays[d.weekday]
    },
    myMonthFormate(d) {
      return this.months[d.month]
    },
    isFuture(day, present, month, year) {
      if (present) {
        return false
      }
      let today = new Date();
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      let date = new Date(year, month-1, day);
      return date > today;
    },
    calculateEvents() {
      if (this.uebOverviews.length === 0 && this.holidayOverviews.length === 0 && (this.mode === 'holiday' || this.mode === 'ueb')) {
        this.events = [];
        return;
      }
      let events = [];
      if (this.mode === 'holiday') {
        let evnt = null;
        for (let i = 0; i < this.holidayOverviews.length; i++) {
          let start = new Date(`${this.holidayOverviews[i].date}T12:00`)
          let end = new Date(`${this.holidayOverviews[i].date}T12:00`)
          let color = "#095996";
          if (evnt === null) {
            evnt = {
              id: getUid(),
              name: "U ",
              start: start,
              end: end,
              color: color,
              timed: false,
              amount: this.holidayOverviews[i].amount,
            };
          } else {
            const diffTime = Math.abs(evnt.end - start);
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays === 1 && this.holidayOverviews[i].amount === 1) {
              // continue event
              evnt.end = end;
              evnt.amount += this.holidayOverviews[i].amount;
            } else {
              // push previous event
              evnt.name = (evnt.amount + '').replace('.', ',') + (evnt.amount === 1 ? ' Tag' : ' Tage');
              events.push(evnt);
              // start new event
              evnt = {
                id: getUid(),
                name: "U ",
                start: start,
                end: end,
                color: color,
                timed: false,
                amount: this.holidayOverviews[i].amount,
              };
            }
          }
        }
        if (evnt !== null) {
          evnt.name = (evnt.amount + '').replace('.', ',') + (evnt.amount === 1 ? ' Tag' : ' Tage');
          events.push(evnt);
        }
      } else if (this.mode === 'ueb') {
        for (let i = 0; i < this.uebOverviews.length; i++) {
          let start = new Date(`${this.uebOverviews[i].date}T12:00`)
          let end = new Date(`${this.uebOverviews[i].date}T12:00`)
          if (this.uebOverviews[i].sum_pos !== 0) {
            // positive ueb event
            let evnt = {
              id: getUid(),
              name: (this.uebOverviews[i].sum_pos + '').replace('.', ',') + ' Std. aufgebaut',
              start: start,
              end: end,
              color: "#28a745",
              timed: false,
            };
            events.push(evnt);
          }
          if (this.uebOverviews[i].sum_neg !== 0) {
            // negative ueb event
            let evnt = {
              id: getUid(),
              name: (this.uebOverviews[i].sum_neg * -1 + '').replace('.', ',') + ' Std. abgebaut',
              start: start,
              end: end,
              color: "#dc3545",
              timed: false,
            };
            events.push(evnt);
          }
        }
      } else if (this.mode === 'rb') {
        for (let i = 0; i < this.rbs.length; i++) {
          if (this.rbs[i] && this.rbs[i].length) {
            for (let j = 0; j < this.rbs[i].length; j++) {
              let rb = this.rbs[i][j];
              let start = new Date(`${this.date.substring(0, 8)}${('' + (rb.day + 1)).padStart(2, '0')}T12:00`)
              let end = new Date(`${this.date.substring(0, 8)}${('' + (rb.day + 1)).padStart(2, '0')}T12:00`)
              // negative ueb event
              let evnt = {
                id: getUid(),
                name: rb.von + ' - ' + rb.bis,
                start: start,
                end: end,
                color: "#f5d32c",
                timed: false,
              };
              events.push(evnt);

            }
          }
        }
      } else if (this.mode === 'soll') {
        for (let i = 0; i < this.soll.length; i++) {
          let total = this.ist[i] - this.soll[i];
            let start = new Date(`${this.date.substring(0,8)}${('' + (i+1)).padStart(2, '0')}T12:00`)
            let end = new Date(`${this.date.substring(0,8)}${('' + (i+1)).padStart(2, '0')}T14:00`)
            let color = total >= 0 ? "#28a745" : "#dc3545";
            if (this.soll[i] === 0) {
              color = "#f6e136";
            }
              // negative ueb event
              let evnt = {
                id: getUid(),
                name: 'Soll: ' + (this.soll[i] + '').replace('.', ',') + ' Std., Ist: ' + (this.ist[i] + '').replace('.', ',') + ' Std.',
                start: start,
                end: end,
                color: color,
                timed: false,
              };
              events.push(evnt);
        }
      } else {
        for (let i = 0; i < this.floats.length; i++) {

            let start = new Date(`${this.date.substring(0,8)}${('' + (i+1)).padStart(2, '0')}T12:00`)
            let end = new Date(`${this.date.substring(0,8)}${('' + (i+1)).padStart(2, '0')}T12:00`)
            let color = "#28a745";
              // negative ueb event
              let evnt = {
                id: getUid(),
                name: (this.floats[i] + '').replace('.', ',') + ' ' + this.unitName,
                start: start,
                end: end,
                color: color,
                timed: false,
              };
              if (this.floats[i] !== 0) {
                events.push(evnt);
              }
        }
      }
      console.log(events)
      this.events = events;
    },
  },
  }
</script>

<style lang="scss">

.v-calendar .v-event {
  pointer-events: none;
}
.clickable {
  pointer-events: auto !important;
}

.theme--light.v-label {
  color: black;
}


.v-calendar-weekly__head-weekday {
  color: black !important;
  background-color: #e4e5e6 !important;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  margin-right: -1px;
}

</style>
